<template>
  <div>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <b-col cols="12" class="mb-1">
          <!-- <div class="d-flex align-items-center justify-content-end">
            <b-button @click="exportExcel(
                pcc,
                ['Product Name', 'Category', 'Total Request', 'Periode'],
                ['name', 'category', 'total', 'period'],
                ['Request PCC'],
                formatJson
              )" variant="primary"
              >Export Excel</b-button
            >
          </div> -->
        </b-col>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="mr-1 per-page-selector d-inline-block ml-50"
          />
          <b-button v-b-modal.add-category variant="primary"
            >Add Category</b-button
          >
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="d-inline-block"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <b-table
        class="border"
        responsive
        striped
        :items="param"
        :fields="paramFields"
      >
        <template #cell(action)="paramData">
          <div class="d-flex">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="mr-1 btn-icon"
              @click="editModal(paramData.item.cat_comp_id,paramData.item.compare_category)"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="mr-1 btn-icon"
                @click="showMsgBoxDelete(paramData.item.cat_comp_id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <b-row
        v-if="!isBusy"
        v-for="(item, index) in param"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.compare_category }}</strong>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="mr-1 btn-icon"
              @click="editModal(item.cat_comp_id,item.compare_category)"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="mr-1 btn-icon"
                @click="showMsgBoxDelete(item.cat_comp_id)"
              >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      title="Add New Category"
      hide-footer
      id="add-category"
      centered
      hide-header-close
    >
      <b-form @submit.prevent="addParam">
        <b-form-group label-for="value">
          <template slot="label">
            <span>Name <strong class="text-danger">*</strong></span>
          </template>
          <b-form-input id="title" required v-model="new_param" />
        </b-form-group>
        <b-form-group class="d-flex justify-content-end">
          <b-button
            type="button"
            variant="light"
            class="mr-1"
            @click="$bvModal.hide('add-category')"
            :disabled="form.isLoading"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" :disabled="form.isLoading">
            Save
          </b-button>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal
      title="Edit Category"
      hide-footer
      id="edit-category"
      centered
      hide-header-close
    >
      <b-form @submit.prevent="editParam">
        <b-form-group label-for="value">
          <template slot="label">
            <span>Name <strong class="text-danger">*</strong></span>
          </template>
          <b-form-input required v-model="edit_param_name" />
        </b-form-group>
        <b-form-group class="d-flex justify-content-end">
          <b-button
            type="button"
            variant="light"
            class="mr-1"
            @click="$bvModal.hide('edit-category')"
            :disabled="form.isLoading"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" :disabled="form.isLoading">
            Save
          </b-button>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BSpinner,
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import RatingDetailPccTable from '@/views/admin/pcc/RatingDetailPCCTable'

export default {
  components: {
    BSpinner,
    BTable,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    VSelect,
    BForm,
    BFormGroup,
    BFormInput,
    BPagination,
    BModal,
    RatingDetailPccTable,
  },

  directives: {
    Ripple,
    VBModal,
  },

  data() {
    return {
      sortBy: 'start_datetime',
      sortDesc: true,
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      param: [],
      paramFields: [
        {
          key: 'compare_category',
          label: 'Category Name',
          sortable: true,
        },
        'Action'
      ],
      selectedPCC: '',
      new_param: '',
      edit_param_id: '',
      edit_param_name: '',
      selectedPeriod: '',
      searchWord: '',
      form: { isLoading: false },
    }
  },

  watch: {
    perPage() {
      this.fetchAllParam()
    },
    currentPage() {
      this.fetchAllParam()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
  },

  mounted() {
    this.fetchAllParam()
  },

  methods: {
    fetchAllParam() {
      this.isBusy = true

      this.$http
        .get('/compare-product/category', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            s: this.searchWord.toString().trim()
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.param = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    searchByTitle: debounce(function() {
      this.fetchAllParam()
    }, 200),

    changePage(page) {
      this.currentPage = page
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchAllParam()
    },

    exportExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'name') {
          data = v.product.PRODUCT
        }

        if (j === 'category') {
          data = v.product.category ? v.product.category.name : ''
        }
        
        if (j === 'total') {
          data = v.total
        }

        return data
      }))
    },
    addParam() {
      this.form.isLoading = true

      this.$http
        .post('/compare-product/category', {
          name: this.new_param
        })
        .then(() => {
          this.$notif(
            'Success',
            'Param successfully added.',
            'success'
          )
          this.$bvModal.hide('add-category')
          this.new_param = ''
          this.fetchAllParam()
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => (this.form.isLoading = false))
    },
    editModal(id,name){
      console.log(id)
      console.log(name)
      this.edit_param_id = id
      this.edit_param_name = name
      this.$bvModal.show('edit-category')
    },
    editParam() {
      this.form.isLoading = true

      this.$http
        .post('/compare-product/edit-category', {
          id: this.edit_param_id,
          name: this.edit_param_name
        })
        .then(() => {
          this.$notif(
            'Success',
            'Param successfully edited.',
            'success'
          )
          this.$bvModal.hide('edit-category')
          this.edit_param_id = ''
          this.edit_param_name = ''
          this.fetchAllParam()
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => (this.form.isLoading = false))
    },
    deleteParam(id) {
      return this.$http.delete(`compare-product/category/${id}`)
    },

    showMsgBoxDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteParam(id)
              .then(() => {
                this.$notif(
                  'Success',
                  'Param deleted.',
                  'success'
                )
                this.fetchAllParam()
              })
              .catch(err => {
                this.$notif('Error', `${err.message}`, 'error')
              })
          }
        })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
